import React from 'react';
import { Settings } from 'lucide-react';
export function SupportFooter() {
  return <footer className="py-8 border-t border-zinc-900 bg-zinc-950 text-center" data-id="element-155">
      <div className="flex items-center justify-center gap-2 text-zinc-500 hover:text-zinc-400 transition-colors" data-id="element-156">
        <Settings className="w-5 h-5" data-id="element-157" />
        <a href="mailto:EbookDreamShop@gmail.com" className="text-sm font-medium" data-id="element-158">
          Soporte: EbookDreamShop@gmail.com
        </a>
      </div>
      <p className="text-xs text-zinc-700 mt-4" data-id="element-159">
        © {new Date().getFullYear()} Artista Marcial Completo. Todos los
        derechos reservados.
      </p>
    </footer>;
}